import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Lock, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // Check if already logged in
  React.useEffect(() => {
    const token = localStorage.getItem('bozs-admin-token');
    if (token) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('bozs-admin-token', response.data.token);
      toast.success('Giriş başarılı!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Giriş başarısız. Kullanıcı adı veya şifre hatalı.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #8b6f47, #6d5637)' }}>
      <div className="w-full max-w-md p-8 rounded-2xl" style={{ background: 'rgba(255, 255, 255, 0.95)', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2" style={{ color: '#2d1f14' }}>BOZ'S</h1>
          <p className="text-sm" style={{ color: '#6b5444' }}>Admin Paneli Girişi</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Label htmlFor="username" className="flex items-center gap-2 mb-2" style={{ color: '#2d1f14' }}>
              <User className="h-4 w-4" />
              Kullanıcı Adı
            </Label>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Kullanıcı adınızı girin"
              required
              data-testid="admin-username-input"
              className="w-full"
            />
          </div>

          <div>
            <Label htmlFor="password" className="flex items-center gap-2 mb-2" style={{ color: '#2d1f14' }}>
              <Lock className="h-4 w-4" />
              Şifre
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifrenizi girin"
              required
              data-testid="admin-password-input"
              className="w-full"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full"
            style={{ background: '#8b6f47', color: 'white' }}
            data-testid="admin-login-button"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm underline"
            style={{ color: '#6b5444' }}
          >
            Menüye Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
